<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong><i class="cui-list icons  mr-2"></i> RTO Handover </strong>           
          </div> 
          <div class="box" id="addform">
            <form @submit.prevent="validateForm('form-1')" data-vv-scope="form-1">
              <b-row>
                <b-col md="6" >
                <b-form-group label="Pickup Location"  :label-cols="3" >
                  <b-form-select name="pickuplocationname" v-model="customer.pickuplocationmasterid" v-validate="'required'" :class="{'input': true, 'is-danger': errors.has('form-1.pickuplocationname') }">
                    <option :value="selected">--Select--</option>
                    <option :value="pickup.pickuplocationmasterid" v-for="pickup in pickuplocation">{{ pickup.pickuplocationmasterid }} {{ pickup.pickuplocationname }}</option>
                  </b-form-select>
                  <span style="width: 270px;" v-show="errors.has('form-1.pickuplocationname')" class="help is-danger">{{ errors.first('form-1.pickuplocationname') }}</span>
                </b-form-group>
                </b-col>
                <b-col md="6" >
                 <b-button size="md" variant="primary" type="submit">Show</b-button>
                </b-col>
              </b-row>  
            </form>
          </div>
          <div class="table-responsive" id="Pickuptable" style="display:none">
              <input type="hidden" name="deliveryagentmasterId" id="deliveryagentmasterId" value="">
              <table class="table table-striped table-bordered">
                  <thead>
                      <tr v-if="data.length>0">
                          <th> Action</th>
                          <th style="display:none"> Sys User Master Id</th>
                          <th> Location </th>
                          <th>Type</th>
                          <th> Address</th>
                          <th>State</th>
                          <th>Location ID</th>
                          <th>Poc Name</th>
                          <th>Mobile Number</th>
                      </tr>
                  </thead>
                  <tbody>
                      <tr v-for="value in data">
                          <td>
                            Handover                       
                          </td>
                          <td>{{ value.pickuplocationname }}</td>
                          <td>{{ value.pickuplocationtype }}</td>
                          <td>{{ value.pickuplocationaddress }}</td>
                          <td>{{ value.pickuplocationstate }}</td>
                          <td>{{ value.pickuplocationpincode }}</td>
                          <td>{{ value.pocname }}</td>
                          <td>{{ value.pocmobilenumber }}</td>
                      </tr>
                  </tbody>
              </table>
          </div>
          <div style="display:none">
              <table id="table" width="100%">
                  <tr>
                      <td colspan="4" style="text-align:center;font-size:25px;">RTO Sheet</td>
                  </tr>
                  <tr>
                      <td colspan="4">Vendor Name:</td>
                  </tr>
                  <tr>
                      <td colspan="4">Handover Count:</td>
                  </tr>
                  <tr>
                      <th>Order Id</th>
                      <th>Pickup Location Type</th>
                      <th>Service Type</th>
                      <th>Shipment Id</th>
                  </tr>
                  <tr v-for="v in data1">
                      <td>{{ v.orderid }}</td>
                      <td>{{ v.pickuplocationtype }}</td>
                      <td>{{ v.servicetype }}</td>
                      <td>{{ v.shippingid }}</td>
                  </tr>
                  <tr>
                      <td colspan="2">Date : </td>
                      <td colspan="2">Recived By : </td>
                  </tr>
              </table>
          </div>
        </b-card>
      </b-col>
    </b-row>      
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function () {
    return {
      name: 'rtoHandover',
      data: [],
      data1: [],
      customer: {},
      pickuplocation: {}
    }
  },
  created: function () {
    this.displaypickuplocations()
  },
  methods: {
    validateForm (scope) {
      this.$validator.validateAll(scope).then((result) => {
        if (result) {
          this.showData()
        }
      })
    },
    printMe: function (parentpickuplocationmasterid) {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const obj = {
        pickuplocationmasterid: `${userInfo.pickuplocationmasterid}`,
        parentpickuplocationmasterid: `${parentpickuplocationmasterid}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/GetWHRTOHandoverPendingLst`, obj)
        .then((result) => {
          this.data1 = result.body
          setTimeout(function () {
            var divToPrint = document.getElementById('table')
            var htmlToPrint = '' +
              '<style type="text/css">' +
              'table th, td {' +
              'border-collapse: collapse;' +
              '}' + ' th, td {' + ' padding: 5px;  text-align: left;' + '}' +
              '</style>'
            htmlToPrint += divToPrint.outerHTML
            var newWin = window.open('')
            newWin.document.write(htmlToPrint)
            newWin.print()
            newWin.close()
          }, 100)
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    },
    displaypickuplocations: function () {
      this.$http
        .post(`${CONSTANTS.API_URL}/PickUpLocationMasterGetAll`)
        .then(result => {
          this.pickuplocation = result.body
        })
        .catch(ex => {
          alert(ex)
        })
    },
    showData: function () {
      const customerGetobj = {
        pickuplocationmasterid: `${this.customer.pickuplocationmasterid}`
      }
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/GetVendorwiseWHRTOHandoverPendingLst`, customerGetobj)
        .then((result) => {
          if (result.body[0].returnmsg) {
            alert('No Records Found  ')
            var Pickuptable1 = document.getElementById('Pickuptable')
            Pickuptable1.style.display = 'none'
          } else {
            this.data = result.body
            var Pickuptable = document.getElementById('Pickuptable')
            Pickuptable.style.display = 'block'
          }
        })
        .catch((ex) => {
          console.log('error', ex)
        })
    }
  }
}
</script>

